import { render } from "./AccountStripeMembership.vue?vue&type=template&id=649d55d5"
import script from "./AccountStripeMembership.vue?vue&type=script&lang=js"
export * from "./AccountStripeMembership.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__